import * as React from 'react';
import { Engine } from '@websky/core';
import { ThemeProvider } from '@websky/core/src/theme';

import theme from '../../theme/theme';
import '../../theme/variables.css';
import Head from '@websky/core/src/Head';
import { RenderersProvider } from '@websky/core/src/renderProps';
import { renders } from '../../renders';

const EngineComponent: React.FC = () => {
	return (
		<RenderersProvider value={renders}>
			<ThemeProvider value={theme}>
				<Head />
				<Engine />
			</ThemeProvider>
		</RenderersProvider>
	);
};

export default EngineComponent;
